import { useBreakpoint } from '@laborability/commons';
import {
  COLORS,
  IconCrossComponent,
  IconLikeComponent,
  IconsSize,
  IconsStyle,
  LBTButton,
  LBTButtonIcon,
  LBTLabel,
} from '@laborability/components';
import { Modal, Paper, Stack } from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  children: string;
  onClose: () => void;
  onSubmitLabel?: string;
  datatestidIcon?: string;
  datatestidButton?: string;
}

export default function MandatoryDialog({
  open,
  title,
  children,
  onClose,
  onSubmitLabel = 'Conferma',
  datatestidIcon,
  datatestidButton,
}: Props) {
  const { isDesktop } = useBreakpoint();
  return (
    <Modal
      open={open}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        style={{
          width: isDesktop ? '584px' : '90%',
          borderRadius: '24px',
        }}
      >
        <Stack direction="column" spacing="24px" padding="16px">
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="space-between"
          >
            <LBTLabel
              style={{ marginRight: '1px' }}
              textAlign="left"
              variant="miscTitleSource"
            >
              {title}
            </LBTLabel>
            <LBTButtonIcon
              datatestid={datatestidIcon}
              size="small"
              onClick={onClose}
            >
              <IconCrossComponent
                style={IconsStyle.FILLED}
                size={IconsSize.MEDIUM}
                color={COLORS.getInstance().BW_GREYS_JET_BLACK}
              />
            </LBTButtonIcon>
          </Stack>
          <LBTLabel textAlign="left" variant="miscDescription">
            {children}
          </LBTLabel>
          <Stack direction="row" spacing="16px" justifyContent="flex-end">
            <LBTButton
              fullWidth
              variant="contained"
              size="medium"
              onClick={onClose}
              color="primary-negative"
              datatestid={datatestidButton}
              startIcon={
                <IconLikeComponent
                  size={IconsSize.MEDIUM}
                  style={IconsStyle.FILLED}
                  color={COLORS.getInstance().WHITE}
                />
              }
            >
              {onSubmitLabel}
            </LBTButton>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
}
